import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { withSetPropAction } from "./helpers/withSetPropAction"
import {
  CruiseDetailsPlaceholderModel,
  StripeSubscriptionModel,
  TripModel,
  UserModel,
  AgentProfileModel,
} from "@cruisen/react-shared"
import { NavigatorMessage } from "@cruisen/contract"

const TripNavigatorStateModel = types.model({
  readMessageIndex: types.integer,
  lastMessageIndex: types.integer,
  lastMessageDate: types.integer,
})
export type TripNavigatorState = Instance<typeof TripNavigatorStateModel>

export const RootStoreModel = types
  .model("RootStore")
  .props({
    loggedInUser: types.maybeNull(UserModel),
    agentProfile: types.maybeNull(AgentProfileModel),
    stripeSubscription: types.maybeNull(StripeSubscriptionModel),
    activeTrip: types.maybeNull(TripModel),
    isCruisenDeveloper: types.optional(types.boolean, false),
    isAuthLoading: types.optional(types.boolean, true),
    isTripLoading: types.optional(types.boolean, true),
    navigatorStates: types.map(TripNavigatorStateModel),
    messages: types.map(types.array(types.frozen<NavigatorMessage>())),
    cruiseDetailsPlaceholderData: types.maybeNull(CruiseDetailsPlaceholderModel),
    paymentRequest: types.maybeNull(types.string),
    activeFileDropZone: types.maybeNull(types.string),
    visibleModal: types.maybeNull(
      types.enumeration(["startSubscription", "inactiveSubscription", "editTrip"]),
    ),
  })
  .actions(withSetPropAction)

export interface RootStore extends Instance<typeof RootStoreModel> {}
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {}
